import { $k18n } from '@/common/i18n';
import React from 'react';
import { StyleProp, Text, TextProps, TextStyle } from 'react-native';

// 多语言——参数可以直接为jsx元素
interface k18nProProps {
    text?: string;
    id?: string;
    params?: {
        [key: string]: JSX.Element | string | Number;
    };
    outerStyle?: StyleProp<TextStyle>;
}

export const k18nPro = (k18n: k18nProProps & Partial<TextProps>) => {
    const { id, params, outerStyle, text } = k18n;
    if (!id && !text) return <Text {...k18n} />;
    const resLang = id ? $k18n({ id }) : $k18n({ text });
    let _resLang = resLang;
    const texts = [];
    const split = ['{', '}'];
    let start = 0;
    let index = _resLang.indexOf(split[start % 2]);
    while (index >= 0) {
        const sub = _resLang.slice(0, index + (start % 2));
        _resLang = _resLang.slice(index + (start % 2));
        console.log('k18nPro:::', _resLang);
        start++;
        index = _resLang.indexOf(split[start % 2]);
        texts.push(sub);
    }
    if (_resLang.length > 0) texts.push(_resLang);
    const regex = /{[^{}]*}/g;
    const foundParams = resLang.match(regex) || ([] as string[]); // > Array ["{x}", "{y}"]
    const _foundParams = foundParams.map(x => x.substring(1, x.length - 1)); // > Array ['x', 'y']
    return (
        <Text style={outerStyle} {...k18n}>
            {texts.map(text => {
                const i = foundParams.indexOf(text);
                if (i > -1) return params?.[_foundParams[i]] || text;
                else return text;
            })}
        </Text>
    );
};
